import RequestHandler from "./RequestHandler";

function OrganizationLicenseAPI() {
    const baseOrganizationLicenseAPI = "organization-licenses";

    async function validateLicenseSubscription(sessionId) {
        try {
            const result = await RequestHandler.get(
                `${baseOrganizationLicenseAPI}/validate-subscription/${sessionId}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function createLicenseCheckoutSession(licenseId) {
        try {
            const result = await RequestHandler.get(
                `${baseOrganizationLicenseAPI}/create-checkout-session/${licenseId}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    return {
        validateLicenseSubscription,
        createLicenseCheckoutSession,
    };
}

export default OrganizationLicenseAPI();
